import { createContext, useContext, useState, type ReactNode } from 'react';

export type MobileNavContextType = {
  isOpen: boolean;
  toggleDrawer: () => void;
  closeDrawer: () => void;
  openDrawer: () => void;
};

export const MobileNavContext = createContext<MobileNavContextType | null>(
  null
);

export const MobileNavProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => setIsOpen((prev) => !prev);
  const closeDrawer = () => setIsOpen(false);
  const openDrawer = () => setIsOpen(true);

  return (
    <MobileNavContext.Provider
      value={{ isOpen, toggleDrawer, closeDrawer, openDrawer }}
    >
      {children}
    </MobileNavContext.Provider>
  );
};

export const useMobileNav = () => {
  const context = useContext(MobileNavContext);
  if (!context) {
    throw new Error('useMobileNav must be used within MobileNavProvider');
  }
  return context;
};
